import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function World({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'22px'} height={'22px'} viewBox={'0 0 24 24'}>
        <path
          d="M11 22C10.46 22 9.92 21.96 9.4 21.88C9.37 21.88 9.34 21.88 9.31 21.87C4.04 21.05 0 16.49 0 11C0 10.59 0.02 10.19 0.07 9.8C0.07 9.77 0.07 9.73 0.08 9.7C0.72 4.24 5.38 0 11 0C12.02 0 13.03 0.14 14 0.42C14.61 0.15 15.29 0 16 0C18.76 0 21 2.24 21 5C21 5.39 20.95 5.77 20.87 6.13C21.61 7.64 22 9.31 22 11C22 17.07 17.07 22 11 22ZM10.5 19.99C10.67 19.99 10.83 20 11 20C15.96 20 20 15.96 20 11C20 10.17 19.88 9.34 19.66 8.54C18.97 9.46 18.09 10.34 17.19 11.23L16.71 11.7C16.32 12.09 15.69 12.09 15.3 11.7L14.82 11.23C12.86 9.28 11 7.45 11 5C11 3.9 11.36 2.88 11.96 2.05C11.64 2.02 11.32 2 11 2C6.81 2 3.29 4.87 2.29 8.75L6.51 8.37C7.1 8.32 7.65 8.61 7.94 9.12L9.73 12.27L12.47 13.84C12.86 14.06 13.13 14.44 13.2 14.89C13.28 15.33 13.15 15.78 12.86 16.12L10.5 18.88V20V19.99ZM2 10.78C2 10.85 2 10.93 2 11C2 15.1 4.75 18.56 8.5 19.65V18.69C8.5 18.33 8.63 17.98 8.86 17.71L10.95 15.27L8.62 13.94C8.39 13.81 8.2 13.62 8.07 13.39L6.36 10.4L2 10.79V10.78ZM16 2C14.35 2 13 3.35 13 5C13 6.54 14.37 7.97 16 9.59C17.63 7.97 19 6.55 19 5C19 3.35 17.65 2 16 2ZM16 6C15.31 6 14.75 5.44 14.75 4.75C14.75 4.06 15.31 3.5 16 3.5C16.69 3.5 17.25 4.06 17.25 4.75C17.25 5.44 16.69 6 16 6Z"
          fill="#ABB3BD"
        />
      </svg>
    </div>
  )
}

World.propTypes = {
  className: PropTypes.string,
}
